// Wave 2 (0031), English web-app texts: same shape as golf2App.nl.ts.
export const appChecklistEn = {
    title: 'Checklist',
    hint: 'What needs to come along? The tablet shows the list next to the call and your child ticks it off.',
    empty: 'Nothing on the list yet. Pick below or add your own.',
    suggestions: 'Suggestions',
    suggestionAdd: 'Add {label}',
    addAll: 'Add all',
    newLabel: 'Something else',
    newPlaceholder: 'For example: Goggles',
    add: 'Add',
    labelRequired: 'Enter a word.',
    labelTooLong: 'At most 40 characters.',
    max: 'At most 12 things per list.',
    itemPicto: 'Picture for {label}',
    up: 'Move {label} up',
    down: 'Move {label} down',
    remove: 'Remove {label}',
    previewTitle: 'Next to the call',
    sheetTitle: 'In the bag',
    sheetProgress: '{done} of {total} packed',
    sheetAllDone: 'All packed',
    sheetNone: 'Nothing ticked yet',
    sheetItemDone: '{label}: packed',
    sheetItemOpen: '{label}: not yet',
    items: {
        'swim-trunks': 'Swim trunks',
        swimsuit: 'Swimsuit',
        towel: 'Towel',
        underwear: 'Underpants',
        socks: 'Socks',
        shampoo: 'Shampoo',
        slippers: 'Flip-flops',
        'football-boots': 'Football boots',
        'shin-guards': 'Shin guards',
        'water-bottle': 'Water bottle',
        quran: 'Quran',
        backpack: 'Bag',
        headscarf: 'Headscarf',
        'prayer-cap': 'Prayer cap',
        coat: 'Coat',
        shoes: 'Shoes',
        lunch: 'Lunch',
        fruit: 'Fruit',
        homework: 'Homework',
        reading: 'Reading book',
        'music-lesson': 'Music book',
        'get-dressed': 'Sports clothes',
    },
};
export const appActivitiesEn = {
    section: 'Fixed activity',
    toggle: 'This is a fixed activity',
    toggleHint: 'Like school, mosque class or football: it happens every week, except in the holidays and breaks you choose below.',
    needsRecurrence: 'Choose a repeat first: a fixed activity comes back every week.',
    followSchool: 'Follows the school holidays',
    followSchoolHint: 'During the school holidays of region {region} this activity does not happen.',
    followSchoolNoRegion: 'Choose your school holiday region using Settings below. This region applies to the whole family.',
    regions: { noord: 'North', midden: 'Central', zuid: 'South' },
    pauses: 'Breaks',
    pausesHint: 'Periods in which this activity pauses. You can share a break with other activities.',
    noPauses: 'No breaks yet.',
    newPause: 'New break',
    pauseName: 'Name',
    pauseNamePlaceholder: 'Summer break',
    pauseFrom: 'From',
    pauseTo: 'Up to and including',
    pauseAdd: 'Add break',
    pauseCancel: 'Cancel',
    pauseNameRequired: 'Give the break a name.',
    pauseRangeInvalid: 'Choose an end date on or after the start date, within a year.',
    pausePresets: {
        zomerstop: 'Summer break',
        winterstop: 'Winter break',
        zomervakantie: 'Summer holiday',
    },
    sharedWith: 'Also for: {names}',
    saved: 'Fixed activity saved',
    saveFailed: 'The event was saved, but the breaks were not. Please try again.',
    barLabel: '{title}, {range}',
    schoolHoliday: 'School holiday',
    pause: 'Break',
    stops: 'Paused: {names}',
    stopsNone: 'No fixed activity pauses then.',
    sheetSchoolHint: 'School holidays come from the Dutch government, for your region. A fixed activity that follows them does not happen then.',
    sheetPauseHint: 'In this period the activities below do not happen: no call, no ride.',
    editPause: 'Edit break',
    deletePause: 'Remove break',
    deletePauseConfirm: 'Are you sure? The activities will then simply happen in this period.',
    pauseDeleted: 'Break "{name}" removed',
    pauseUpdated: 'Break "{name}" saved',
    fixedChip: 'Fixed activity',
};
//# sourceMappingURL=golf2App.en.js.map